import { atom } from 'recoil';
import Cookies from 'js-cookie';

export const pidState = atom<string | null | undefined>({
  key: 'pidState',
  default: Cookies.get('pid'),
});
